/**
 * Possible input width
 */
const widths = [2, 4, 16, 'full'];
/**
 * Possible tootltip postions
 */
const tooltipPositions = ['input', 'label'];
const classFieldset = 'mg-c-input--fieldset';
const classDisabled = 'mg-c-input--disabled';
const classReadonly = 'mg-c-input--readonly';
const classVerticalList = 'mg-c-input--vertical-list';

export { classReadonly as a, classDisabled as b, classFieldset as c, classVerticalList as d, tooltipPositions as t, widths as w };

//# sourceMappingURL=mg-input.conf-712c7bb6.js.map